import { render } from "./tagsView.vue?vue&type=template&id=2162f59b&scoped=true&ts=true"
import script from "./tagsView.vue?vue&type=script&lang=ts"
export * from "./tagsView.vue?vue&type=script&lang=ts"

import "./tagsView.vue?vue&type=style&index=0&id=2162f59b&lang=scss&scoped=true"

import exportComponent from "E:\\bjft\\bjjc-merchant-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2162f59b"]])

export default __exports__